import { useServices } from "@core/servicesContext";
import {
	AsyncResult,
	emptyPaginatedDataResult,
	PaginatedDataResult,
	PromiseResult,
	resolvedAsyncResult,
	resolvedPromiseResult,
	useMappedStore,
	usePromise,
	useStoredData,
} from "@utils/hooks";
import { ApplicationLevel } from "@domain/program/programDraft";
import { Application, ApplicationFilterOptions } from "./application";

export function useApplication(applicationId: string): AsyncResult<Application | undefined> {
	const { applicationService } = useServices();
	return applicationService
		? useStoredData(applicationId, applicationService.applicationStore, [applicationId])
		: resolvedAsyncResult(undefined);
}

export function useDegreeLevel(): PromiseResult<ApplicationLevel[] | null> {
	const { applicationService } = useServices();
	return applicationService ? usePromise(() => applicationService.getDegreeLevel(), []) : resolvedPromiseResult(null);
}

export function useMyApplication(id?: string): PromiseResult<Application | undefined> {
	const { applicationService } = useServices();
	return applicationService
		? usePromise(() => applicationService.getMyApplication(), [id])
		: resolvedPromiseResult(undefined);
}

export function useApplicationByUser(id: string, currentUser?: string): PromiseResult<Application | undefined> {
	const { applicationService } = useServices();
	return applicationService
		? usePromise(() => applicationService.getApplication(id, currentUser), [id, currentUser])
		: resolvedPromiseResult(undefined);
}

export function useApplicationsLists(
	filterOption: ApplicationFilterOptions | undefined
): PaginatedDataResult<Application | undefined> {
	const { applicationService } = useServices();
	return applicationService
		? useMappedStore({ filterOption }, applicationService.applicationsStore, [filterOption])
		: emptyPaginatedDataResult<Application | undefined>();
}
